import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Download } from "lucide-react";
import { useModals } from "./ModalContext";

const NAV = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/learning-journey", label: "Learning Journey", testid: "nav-learning-journey" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/contact", label: "Contact Us", testid: "nav-contact" },
];

export default function Header() {
  const { openProspectus } = useModals();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkCls = ({ isActive }) =>
    `text-sm font-semibold tracking-wide transition-colors pb-1 border-b-2 ${
      isActive ? "text-navy border-gold" : "text-slate-600 border-transparent hover:text-navy"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2.5 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3 sm:gap-4" data-testid="header-logo-link" aria-label="CASIA home">
          <span className="flex items-center rounded-md bg-navy px-3 py-2">
            <img
              src="/assets/eef-logo.webp"
              alt="The Experiential Education Foundation logo"
              className="h-8 w-auto sm:h-10 lg:h-9 xl:h-11"
            />
          </span>
          <img src="/assets/casia-logo.webp" alt="CASIA logo" className="h-7 w-auto sm:h-9 lg:h-8 xl:h-10" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === "/"} className={linkCls} data-testid={item.testid}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={openProspectus}
            data-testid="header-download-prospectus-button"
            className="hidden items-center gap-2 rounded-md bg-navy px-4 py-2.5 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-navy-700 sm:inline-flex"
          >
            <Download className="h-4 w-4" aria-hidden="true" />
            Download Prospectus
          </button>
          <button
            type="button"
            className="rounded-md p-2 text-navy lg:hidden"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-slate-200 bg-white px-4 py-4 lg:hidden" aria-label="Mobile" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${item.testid}`}
                className={() =>
                  `rounded-md px-3 py-3 text-sm font-semibold ${
                    location.pathname === item.to ? "bg-gold-light text-navy" : "text-slate-600 hover:bg-parchment"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <button
              type="button"
              data-testid="mobile-download-prospectus-button"
              onClick={() => {
                setOpen(false);
                openProspectus();
              }}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-navy px-4 py-3 text-xs font-bold uppercase tracking-wider text-white"
            >
              <Download className="h-4 w-4" aria-hidden="true" />
              Download Prospectus
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
